// CRITICAL: Import appReady FIRST - notifies Capgo before React initialization
// This prevents rollback if React crashes during startup
// eslint-disable-next-line simple-import-sort/imports
import './integrations/capacitor/appReady';
// Polyfill Iterator Helpers for Safari and older browsers
import 'core-js/actual/iterator';
// Initialize Sentry early to catch errors from app startup
import { initSentry, Sentry } from './integrations/sentry';
import './integrations/amplify/amplify';
import './styles/main.css';
import './styles/stream.css';

import { RouterProvider } from '@tanstack/react-router';
import ReactDOM from 'react-dom/client';

import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider';
import reportWebVitals from './reportWebVitals';
import { router, TanStackQueryProviderContext } from './router';
import { logger } from '@/features/logging/service/logger';

initSentry();

// Render the app
const rootElement = document.getElementById('app');
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement, {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      logger.error('Uncaught error', error, errorInfo.componentStack, {
        forceProd: true,
      });
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  });
  root.render(
    <TanStackQueryProvider.Provider {...TanStackQueryProviderContext}>
      <RouterProvider router={router} />
    </TanStackQueryProvider.Provider>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
